<template>
  <div class="row">
    <div class="col col-md-12">
      <p
        v-if="loadGif == false && quantidadeItens == 0"
        style="margin-bottom: 0px"
      ></p>

      <div
        v-if="loadGif && quantidadeItens == 0"
        style="margin-bottom: 30px; margin-top: 30px"
      >
        <button type="button" class="btn btn-sm btn-warning">
          Carregando <img src="/assets/ajax-loader.gif" style="" />
        </button>
      </div>

      <div class="rowLista rowListaEventosHome">
        <div
          v-for="(item, itemIndex) in itensFiltro"
          :key="item.id"
          :item="item"
        >
          <div
            class="list-group-item text-left rounded"
            v-if="filtroSituacao.indexOf(item.situacao) > -1"
            style="margin-bottom: 4px"
            v-bind:style="{
              'background-color': (itemIndex + 1) % 2 === 0 ? '#e9ecef' : '',
            }"
          >
            <div class="row">
              <div class="col col-md-12 d-flex justify-content-between">
                <div
                  style="margin-top: 10px"
                  v-bind:style="{
                    cursor:
                      item.situacao == 3 ||
                      retornaTipoUsuario() == 'Administrador'
                        ? 'pointer'
                        : 'default',
                  }"
                  @click="abrirEvento(item, false)"
                  class="d-flex justify-content-start"
                >
                  <h6>
                    <span class="badge badge-secondary">{{
                      formatarHora(item)
                    }}</span>
                  </h6>
                  <h6 style="margin-left: 10px; margin-top: 1px">
                    {{ item.nome }}
                    <small v-if="item.situacao == 2">
                      <small>Invisivel</small>
                    </small>
                  </h6>
                </div>
                <div
                  style="margin-top: 6px; min-width: 78px"
                  class="text-right"
                >
                  <button
                    type="button"
                    @click="abrirEvento(item, false)"
                    class="btn btn-sm btn-outline-dark"
                    style="font-size: 8px"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Abrir"
                    v-if="
                      retornaTipoUsuario() == 'Administrador' ||
                      retornaTipoUsuario() == 'Apresentador' ||
                      retornaSite() !== '7live' ||
                      (retornaSite() == '7live' && planoAtivo == true) ||
                      (retornaSite() == '7live' &&
                        planoAtivo == false &&
                        itensUsuario.hasOwnProperty(item._id))
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-camera-video"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"
                      />
                    </svg>
                  </button>
                  <button
                    type="button"
                    @click="adquirirEvento(item)"
                    class="btn btn-sm btn-outline-dark"
                    style="margin-left: 10px; font-size: 8px"
                    data-toggle="tooltip"
                    data-placement="top"
                    v-if="
                      retornaTipoUsuario() !== 'Administrador' &&
                      retornaTipoUsuario() !== 'Apresentador' &&
                      retornaSite() == '7live' &&
                      (item.avulso && item.avulso == 'sim') &&
                      !itensUsuario.hasOwnProperty(item._id)
                    "
                    title="Comprar"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-cart2"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <EditPlanoUsuarioPublico
        ref="editPlanoUsuarioPublico"
        @fechar="fecharAdquirirEvento()"
        propView="evento"
      />
    </div>
  </div>
</template>

<script>
import EditPlanoUsuarioPublico from "../edits/EditPlanoUsuarioPublico";

export default {
  name: "ListEventosHome4",
  components: { EditPlanoUsuarioPublico },
  props: {
    itens: { type: Array },
    itensUsuario: {
      type: Object,
      default() {
        return {};
      },
    },
    filtroSituacao: { type: Array, default: () => [] },
    icone: { type: Boolean, default: true },
    gmt: { type: Number, default: 0 },
    loadGif: { type: Boolean, default: true },
    planoAtivo: { type: Boolean, default: false },
    ordemReversa: { type: Boolean, default: false },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    retornaTipoUsuario() {
      return this.$sessao ? this.$sessao.usuario.tipoUsuario : "";
    },
    abrirEvento(item, limpo) {
      var url = "";

      if (this.retornaSite() == "7live") {
        url = "/vid/23/11akUihYuhd/" + this.insertRandomChars(item._id);
      } else {
        url = "/view/" + item._id;
      }

      if (limpo) {
        url = url + "?view=clean";
      }

      if (
        item.situacao == 3 ||
        this.$sessao.usuario.tipoUsuario == "Administrador"
      ) {
        window.open(
          url,
          "newwindow_" + Date.now(),
          "scrollbars=1,width=450,height=450"
        );
      }
    },
    async adquirirEvento(item) {
      await this.$refs.editPlanoUsuarioPublico.carregarItemEvento(item);
      this.$refs.editPlanoUsuarioPublico.abrir();
    },
    fecharAdquirirEvento() {
      this.$emit("recarregar");
    },
    formatarHora(evento) {
      var hora = evento.dataHora.toString().padStart(2, "0");
      var minuto = evento.dataMinuto.toString().padStart(2, "0");

      try {
        var data = new Date();
        data.setHours(evento.dataHora + this.gmt);
        data.setMinutes(evento.dataMinuto);

        hora = data.getHours();
        minuto = data.getMinutes();
      } catch (err) {
        console.log(err);
      }

      return (
        hora.toString().padStart(2, "0") +
        ":" +
        minuto.toString().padStart(2, "0")
      );
    },
    insertRandomChars(text) {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";

      for (let i = 0; i < text.length; i++) {
        const randomChar1 = chars.charAt(
          Math.floor(Math.random() * chars.length)
        );
        const randomChar2 = chars.charAt(
          Math.floor(Math.random() * chars.length)
        );
        result += text.charAt(i) + randomChar1 + randomChar2;
      }

      return result;
    },
  },
  mounted() {
    //window.$('[data-toggle="tooltip"]').tooltip();
  },
  computed: {
    quantidadeItens: function () {
      var filtroSituacao = this.filtroSituacao;

      return this.itens.filter(function (item) {
        return filtroSituacao.indexOf(item.situacao) > -1;
      }).length;
    },
    itensFiltro: function () {
      var filtroSituacao = this.filtroSituacao;

      var arrFiltro = this.itens.filter(function (item) {
        return filtroSituacao.indexOf(item.situacao) > -1;
      });

      if (this.ordemReversa) {
        return arrFiltro.reverse();
      } else {
        return arrFiltro;
      }
    },
  },
  data: function () {
    return {};
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}

/*
.rowListaEventosHome .list-group-item {
  border-color:black;
  border-bottom:0px;
}

.rowListaEventosHome > .list-group-item:last-child {
  border-bottom:1px solid black;
}*/
</style>
